import { Box, Grid, Paper, Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { styles } from "./ProductDetailsSubscriptionBox.styles";
import { BlueButton } from "../../components/Buttons/BlueButton";
import { getSubscriptionBoxAdditionalText, getSubscriptionBoxType } from "./helpers/subscriptionBoxTypesHelper";
import { kneipName } from "../../../constants/ORDER_DETAILS";

export interface IPricesSubscription {
    monthly: number,
    yearly: number,
    currency: string,
}

export interface ISubscriptionBoxProps extends WithStyles<typeof styles> {
    handleCheckout: any;
    rowId: any;
    headlineDisabled?: boolean;
    isAlreadySubscribed?: boolean;
}

const SubscriptionBoxPure: React.FunctionComponent<ISubscriptionBoxProps> = ({
                                                                                 handleCheckout,
                                                                                 rowId,
                                                                                 headlineDisabled,
                                                                                 isAlreadySubscribed,
                                                                                 classes
                                                                             }: ISubscriptionBoxProps) => {

    const handleRequestPricingClick = () => {
        handleCheckout(rowId, true);
    };
    
    const subscriptionBoxType = getSubscriptionBoxType({isSubscribed: isAlreadySubscribed, productId: rowId});
    const subscriptionBoxAdditionalText = getSubscriptionBoxAdditionalText({isSubscribed: isAlreadySubscribed, productId: rowId});

    return <>
        <Grid item xs={6}>
            <Paper elevation={0} className={classes.paper}>
                <Box margin={4} className={classes.card}>
                    {headlineDisabled ? null : <Typography variant="h2">Subscription</Typography>}
                    <div className={classes.explanation}>
                        <Typography variant="body1">{subscriptionBoxType?.text}</Typography>
                        {rowId.includes(kneipName) ? <Typography variant="body1">The fund data will be provided by Kneip Communication S.A. a Deutsche Börse Group company, who will contact you separately. We will therefore pass on your personal data to Kneip in order to contact you.</Typography> : <Typography variant="body1">{subscriptionBoxType?.contactText}</Typography>}
                        <Typography variant="body1">{subscriptionBoxAdditionalText?.text}</Typography>
                    </div>
                    <div className={classes.buttonCheckout}>
                        <BlueButton fullWidth onClick={handleRequestPricingClick}>{subscriptionBoxType?.buttonTitle}</BlueButton>
                    </div>
                </Box>
            </Paper>
        </Grid>
    </>;
};

export const ProductDetailsSubscriptionBox = withStyles(styles)(SubscriptionBoxPure);
